import Vue from 'vue';
import moment from 'moment';

require('moment/locale/es');
Vue.use(require('vue-moment'), {
  moment,
});

// TODO: CHANGE
